import { render, staticRenderFns } from "./ValidaCertidao.vue?vue&type=template&id=5d9a3122&"
import script from "./ValidaCertidao.vue?vue&type=script&lang=js&"
export * from "./ValidaCertidao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports